import GroupAddIcon from '@material-ui/icons/GroupAdd';
import CreateIcon from '@material-ui/icons/Create';
import {
    Box,
    Button, CircularProgress,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    TextField as MUITextField, Typography
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useEffect, useState} from 'react';
import {client} from '../../dataProvider';
import {useResourceContext, useUpdate} from 'react-admin';
import {getUser} from "../../authProvider";

interface Employee {
    id: string;
    label: string;
}

export const AssignedField = ({record}: { record: any }) => {
    const user = getUser();
    const resource = useResourceContext();
    const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);
    const [employee, setEmployee] = useState([]);
    const [onClick, setOnClick] = useState(false);
    const [open, setOpen] = useState(false);
    const [update, {loading, error}] = useUpdate();
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (!onClick) return;
        client('autocomplete/employee', {
            method: 'GET', params: {
                department: "Ufficio",
                page: 1,
                page_size: 1000,
                debt_collection: true,
            }
        })
            .then((response) => setEmployee(response.results))
            .catch((error) => console.error("Failed to fetch employees:", error));
    }, [onClick]);

    const handleAssign = async () => {
        if (selectedEmployee && record) {
            update(resource, record.id, {assigned_id: selectedEmployee.id})
            setOpen(false);
        }
    };
    return user && user.permissions.includes("base.admin_debt_collection") ? (
        <Box display="flex" alignItems="center">
            {
                record.assigned ? (
                    <>
                        <Button variant="outlined" size="small" color="primary" onClick={handleClickOpen}>
                            {loading ? <CircularProgress size={18} thickness={2}/> : <CreateIcon fontSize="small"/>}
                        </Button> {record.assigned.surname} {record.assigned.name}
                    </>
                ) : (
                    <Button variant="outlined" size="small" color="primary" onClick={handleClickOpen}>
                        {loading ? <CircularProgress size={18} thickness={2}/> : <GroupAddIcon fontSize="small"/>}
                    </Button>
                )
            }
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}
                    maxWidth="sm" fullWidth={true}>
                <DialogTitle disableTypography>
                    <Typography variant="h6">Assegna dipendente</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Autocomplete
                        options={employee}
                        getOptionLabel={(option: any) => option.label}
                        fullWidth
                        renderInput={(params) => (
                            <MUITextField
                                {...params}
                                variant="outlined"
                                size="small"
                                placeholder="Dipendente"
                                onClick={() => setOnClick(!onClick)}
                            />
                        )}
                        onChange={(event, newValue) => {
                            setSelectedEmployee(newValue);
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button aria-label="close" onClick={handleClose}>
                        Chiudi
                    </Button>
                    <Button autoFocus onClick={handleAssign} disabled={!selectedEmployee} color="primary">
                        Aggiungi
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    ) : (<div>{record.assigned && `${record.assigned.surname} ${record.assigned.name}`}</div>)
}
